import { observer } from 'mobx-react';
import { FC } from 'react';
import { ControlledDater } from '@monorepo/controlled/src/components/controlled-dater/controlled-dater';
import { Page, Pagebar, PagebarTitle, PagebarActions } from '@monorepo/base/src/components/page/page';
import { Outlet } from 'react-router-dom';
import { useDomainHeaders } from '../../../modules/hooks/theaders/domains.headers';
import {
	groupByMapper,
	IPerformanceOptionsSortBy,
	IPerformanceOptionsSortOrder,
	PerformancesColumnsSnakeCase,
	useReportsList,
} from '../../../modules/hooks/apis/use-reports-list';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../modules/stores';
import { ControlledTable } from '@monorepo/controlled/src/components/table-wrapper/table-wrapper';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { usePageSettings } from '@monorepo/tools/src/lib/hooks/tools/use-page-settings';

export const Domains: FC = observer(() => {
	const { currentRouteWithoutSpecialChars } = useRoute();

	const { performanceStore } = useStores<IAdminxStore>();

	const { columns } = useDomainHeaders({ summary: performanceStore.getData()?.footer });
	const columnVisibility = usePageSettings().tableStore?.getColumnVisibility();
	const defaultSortBy = usePageSettings().tableStore?.getSortingBy();
	const groupByColumns = Object.keys(columnVisibility || {})
		.map((col: string) => {
			if (typeof col === 'string' && columnVisibility && columnVisibility[col]) {
				return groupByMapper[col];
			}
		})
		.filter(val => !!val) as PerformancesColumnsSnakeCase[];
	const limit = 5000;

	const { fetchReports } = useReportsList(
		performanceStore,
		{
			groupBys: [...groupByColumns],
			reportName: 'adx',
			limit,
			sortBy: defaultSortBy?.[0]?.id || IPerformanceOptionsSortBy.Wins,
			sortOrder:
				defaultSortBy?.[0]?.desc !== undefined
					? defaultSortBy[0].desc
						? IPerformanceOptionsSortOrder.Desc
						: IPerformanceOptionsSortOrder.Asc
					: IPerformanceOptionsSortOrder.Desc,
			submit: false,
		},
		{}
	);

	return (
		<Page>
			<Pagebar>
				<PagebarTitle>Domains</PagebarTitle>
				<PagebarActions>
					<ControlledDater />
				</PagebarActions>
			</Pagebar>

			<ControlledTable
				currentRoute={currentRouteWithoutSpecialChars}
				debugProps={{ dataAttrs: [new DataAttribute('id', 'domains_table')] }}
				columns={columns}
				defaultSortBy={defaultSortBy?.[0] ? defaultSortBy : [{ id: IPerformanceOptionsSortBy.Wins, desc: true }]}
				isLoading={performanceStore.getIsLoading()}
				isBarLoader={performanceStore.getIsLoading()}
				data={performanceStore.getData()?.getData() || []}
				fetchReports={fetchReports}
				isSummary={false}
			/>
			<Outlet />
		</Page>
	);
});
